import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Notify } from "../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
class TrunkManagement extends Component {
	constructor(props) {

		super(props);
		this.state = {
			trunkList: [],
			confirmDelete: false,
			selectedTrunkId: 0,
			showAddCreditModal: false,
			sizePerPage: 10
		}
	}
	componentDidMount() {
		this.getTrunk();
		const savedSizePerPage = Cookies.get('trunkListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}


	getTrunk = () => {
		const apiPath = this.props.app.apiPath;

		Fetcher.get(apiPath + '/api/obd/trunks/list')
			.then(res => {
				this.setState({
					trunkList: res,
					showAddCreditModal: false,
					confirmDelete: false,
				})
			})
			.catch(err => { console.log('Error in fetching Trunk List', err) });
	}

	confirmDelete = (status, trunkId) => {
		this.setState({
			confirmDelete: status,
			selectedTrunkId: trunkId
		});
	}

	deleteTrunk = () => {
		const trunkId = this.state.selectedTrunkId;
		
		const data = {
			
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/trunk/'+trunkId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getTrunk();
			})
			.catch(err => {
				console.log('Error in Deleting Trunk', err);
				Notify.notify('Error in Deleting Trunk');
			});

	}

	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	setMessageShow = (status) => {
		this.setState({
			showAddCreditModal: false,
		});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('trunkListsizePerPage', newSizePerPage);
	}

	render() {

		const trunkList = this.state.trunkList;
		var columns;
			columns = [
				{
					dataField: 'trunkId',
					text: 'Trunk Id',
					sort: true,
					hidden: false
				},
				{
					dataField: 'trunkName',
					text: 'Trunk Name',
					sort: true,
					searchable: true
				},
				{
					dataField: 'pilotNumber',
					text: 'Pilot Number',
					sort: true,
					searchable: true
				},
				{
					dataField: 'channels',
					text: 'Channels',
					sort: true,
					searchable: true
				},
				{
					dataField: 'cps',
					text: 'CPS',
					sort: true,
					searchable: true
				},
				{
					dataField: 'action',
					text: 'Action',
					sort: false,
					searchable: false
				},];
		
		const trunk = Array.isArray(trunkList) ? trunkList.map((trunks, index) => {
				let action = [ <Link data-tip="Edit Trunk" key={`${index}-edit-trunk`} className="edit-trunk" to={`${this.props.app.urlPrefix}/update-trunk/${trunks.trunkId}`}><i className="fa fa-edit"></i></Link> ];
				action.push(<a data-tip="Delete Trunk" key={`${index}-delete-trunk`} className="delete-trunk" onClick={(e) => { this.confirmDelete(true, trunks.trunkId) }} href="#"><i className="fa fa-trash"></i></a>);
				//action.push( <a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={( e ) => { this.confirmDelete( true, cli.cliId ) }} href="#"><i className="fa fa-trash"></i></a> )
				return {
					trunkId: trunks.trunkId,
					trunkName: trunks.trunkName,
					pilotNumber: trunks.pilotNumber,
					channels: trunks.channels,
					cps: trunks.cps,
					action: action
				};
			
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'trunkId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: trunk.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				{/*<Card.Header>Users List<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span></Card.Header>*/}
				<Card.Header>Trunk List</Card.Header>
				<Card.Body>
					<div className="widget-list-table-cont">
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.trunkList ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (
									<ToolkitProvider
										keyField="trunkId"
										data={trunk}
										columns={columns}
										search
										bootstrap4

									>
										{
											props => (
												<div className="">
													Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
													<span className="search-cont"><SearchBar  {...props.searchProps} /></span>
													<ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
													{/*<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span>*/}
													{/*<Link className="float-right btn btn-default btn-primary" to={`${this.props.app.urlPrefix}/add-cli`}>Allocate CLI</Link>*/}
													
													<BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
													<PaginationListStandalone {...paginationProps} />
													<ReactTooltip />
												</div>
											)
										}
									</ToolkitProvider>
								)
							}
						</PaginationProvider>}
					</div>

					<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete Trunk
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this Trunk?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteTrunk} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

				</Card.Body>
			</Card>

		);
	}
}

export default TrunkManagement;